import EmbedConversationPreview from '../../courses/preview/EmbedConversationPreview';
import ConversationStepHistory from '../../students/workspace/ConversationStepHistory';
import { getBlockType } from '../../../variables/exerciseBlockTypes';
import { BlockTypeBadge } from '../../courses/preview/blockTypeIcons';
import BlurredPreviewWrapper from '../../courses/preview/BlurredPreviewWrapper';
import NotePin from '../../students/workspace/NotePin';
import StudentAvatar from './StudentAvatar';

// Group counterpart of WorkspaceTopicSection.jsx's ConversationBlockEntry -
// was entirely missing before this fix (GroupWorkspaceTopicSection.jsx's own
// top comment used to say so explicitly: "embed_conversation's own
// step-history window ... left for a later pass"). GroupWorkspaceTopicSection's
// generic ExerciseBlockEntry only ever reads savedStateByElementId (the
// plain multiple_choice/fill_blank/etc answer table) - embed_conversation
// never writes there at all, it writes StudentConversationProgress/-Step
// instead (already fetched into
// activityByStudentId[studentId].progressByElementId by
// useGroupWorkspaceData.js, just never read by anything in this group view
// until now) - so a conversation's real answers silently never appeared,
// live OR after reload, no matter how many times a student answered.
//
// One row per member who has actually started this conversation - same
// "skip members with nothing to show" convention as GroupExerciseAnswerState,
// each row its own real ConversationStepHistory (not a generic preview -
// same reasoning as the single-student ConversationBlockEntry: showing the
// frozen admin-authored "representative path" preview alongside a member's
// own real history would just be a second, fake, redundant window).
export default function GroupConversationBlockEntry({ block, notesByTarget, members, activityByStudentId, workspaceId, onNotesChanged }) {
   const blockType = getBlockType(block.type) || {};
   const started = members.filter(m => {
      const slice = activityByStudentId[m.studentId];
      const entry = slice && slice.progressByElementId[block.id];
      return entry && entry.steps && entry.steps.length > 0;
   });

   return (
      <div className='course-preview-block'>
         <BlockTypeBadge type={block.type} accent={blockType.accent} label={blockType.label} />
         <BlurredPreviewWrapper elementType='EXERCISE_INTERACTIVE' elementId={block.id} blurEnabled={!!block.blurEnabled}>
            <div className='course-preview-block-content'>
               {started.length === 0 ? (
                  <div className='course-preview-embed-conversation'>
                     <div className='workspace-frozen-content'><EmbedConversationPreview block={block} /></div>
                     <p className='workspace-activity-empty-hint'>Ще ніхто не почав цю розмову.</p>
                  </div>
               ) : (
                  <div className='group-answer-state-list'>
                     {started.map(m => {
                        const entry = activityByStudentId[m.studentId].progressByElementId[block.id];
                        return (
                           <div className='group-answer-state-row' key={m.studentId}>
                              <StudentAvatar studentId={m.studentId} name={m.name} />
                              <div className='group-answer-state-content course-preview-embed-conversation'>
                                 <ConversationStepHistory progress={entry.progress} steps={entry.steps} />
                              </div>
                           </div>
                        );
                     })}
                  </div>
               )}
            </div>
         </BlurredPreviewWrapper>
         <NotePin notes={notesByTarget['exerciseInteractiveElement:' + block.id] || []}
            kind='exerciseInteractiveElement' targetId={block.id} workspaceId={workspaceId} onNotesChanged={onNotesChanged} />
      </div>
   );
}
